import { Pie } from '@visx/shape';
import { Group } from '@visx/group';
import { Text } from '@visx/text';



export const GraphicPie = (props) => {
    const {width, value, innerRadius, fontSizeNumber, fontSizeSymbol, symbolDistanceX, symbolDistanceY, numberDistanceX, className, style} = props;
    const half = width/2

    const lookupColor = (percentage) => {
        if (percentage < 75) return "#cc3232";
        if (percentage < 90) return "#e7b416";
        return "#2dc937";
    };

    const calculateGraphic = (percentageValue = 0) => {

        const color = lookupColor(percentageValue);

        return [
            { symbol: "ADA1", amount: 100, color: '#aaaaaa', percentege: percentageValue },
            { symbol: "ADA", amount: percentageValue, color: color, percentege: 0 },
        ];
    };

    const graphicValue = calculateGraphic(value)

    return (
        <div className={className} style={{...style}} id={props.id}>
            <svg width={width} height={width}> <Group top={half} left={half}>
                <Pie
                    data={graphicValue}
                    pieValue={(data) => data.amount - data.percentege}
                    outerRadius={half}
                    innerRadius={half - innerRadius}
                    padAngle={0.01}
                >
                    {(pie) => {
                        return pie.arcs.map(arc => {
                            return <g key={arc.data.symbol}>
                                <path d={pie.path(arc)} fill={arc.data.color}>  </path>
                            </g>
                        })
                    }}
                </Pie>
                <Text verticalAnchor="middle" textAnchor="middle" fill={lookupColor(graphicValue[0].percentege)} fontFamily="Roboto, Helvetica" fontSize={fontSizeNumber} x={numberDistanceX}>
                    {`${graphicValue[0].percentege}`}
                </Text>
                <Text fill="#aaaaaa" fontWeight={'bold'} fontFamily="Roboto, Helvetica" fontSize={fontSizeSymbol} x={symbolDistanceX} y={symbolDistanceY}>%</Text>
            </Group>
            </svg>
        </div>
    )
}
